<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const router = useRouter();
const store = useStore();
const accountId = computed(() => store.getters.getCurrentAccountId);

const tabs = [
  { label: 'Conta', route: 'general_settings_index' },
  { label: 'Canais', route: 'settings_inbox_list' },
  { label: 'Agentes', route: 'agent_list' },
  { label: 'Equipes', route: 'settings_teams_list' },
  { label: 'Respostas rápidas', route: 'canned_list' },
  { label: 'Etiquetas', route: 'labels_list' },
  { label: 'Atributos Person.', route: 'attributes_list' },
  { label: 'Automação', route: 'automation_list' },
  // Desabilitados no tokyo (sem usabilidade) — descomentar pra reativar
  // { label: 'Macros', route: 'macros_wrapper' },
  // { label: 'Auditoria', route: 'auditlogs_list' },
];

const activeTab = computed(() => {
  const name = route.name;
  return tabs.find(t => name?.startsWith(t.route) || name === t.route)?.route || '';
});

// Hide tabs when inside inbox creation wizard
const inboxWizardRoutes = [
  'settings_inbox_new',
  'settings_inboxes_page_channel',
  'settings_inboxes_add_agents',
  'settings_inbox_finish',
  'settings_teams_new',
  'settings_teams_add_agents',
  'settings_teams_finish',
];
const isWizardRoute = computed(() => inboxWizardRoutes.includes(route.name));

function goTo(tabRoute) {
  router.push({ name: tabRoute, params: { accountId: accountId.value } }).catch(() => {});
}
</script>

<template>
  <div v-if="!isWizardRoute" class="sz-settings-tabs">
    <div
      v-for="tab in tabs"
      :key="tab.route"
      class="sz-settings-tab"
      :class="{ active: activeTab === tab.route }"
      @click="goTo(tab.route)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<style scoped>
.sz-settings-tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid #E5E5E5;
  padding: 0 20px;
  overflow-x: auto;
  flex-shrink: 0;
}
.dark .sz-settings-tabs {
  border-bottom-color: #363840;
}
.sz-settings-tab {
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  transition: color 0.15s, border-color 0.15s;
  font-family: Inter, system-ui, sans-serif;
}
.sz-settings-tab:hover {
  color: #374151;
}
.dark .sz-settings-tab:hover {
  color: #E5E7EB;
}
.sz-settings-tab.active {
  color: #388E3C;
  border-bottom-color: #388E3C;
}
.dark .sz-settings-tab.active {
  color: #4ADE80;
  border-bottom-color: #4ADE80;
}

/* Force settings content to align left instead of center */
.sz-settings-tabs ~ div .mx-auto,
.sz-settings-tabs + div .mx-auto {
  margin-left: 0 !important;
  margin-right: auto !important;
}
</style>
